import { faCircleQuestion, faWindowMaximize } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

const defaultContent =
    <ul>
        <li><Link onClick={() => window.open("mailto:guigoncalves@msn.com")} >Mail</Link></li>
        <li><Link onClick={() => window.open('https://github.com/guigoncalves182', '_blank')}>Github</Link></li>
    </ul>

export let setWidgetIsOpen;

export default function Widget({ content = defaultContent, backgroundColor = '#f2f2f2', accentColor = "#ccc", helperText = "Preciso de ajuda" }) {
    const isMobile = useMediaQuery({ maxWidth: 576 });
    const [isOpen, setIsOpen] = useState(false)
    setWidgetIsOpen = setIsOpen;

    const position = {
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 100,
    }

    const widgetStyle = {
        ...position,
        top: isMobile ? '50%' : 'auto',
        left: isMobile ? '50%' : 'auto',
        transform: isMobile ? 'translate(-50%, -50%)' : 'none',

        width: isMobile ? '90%' : 'auto',
        // height: isMobile ? '90%' : 'auto',
        height: 'auto',
        maxHeight: 'calc(100vh - 40px)',
        bottom: isMobile ? 'auto' : '20px',
        right: isMobile ? 'auto' : '20px',

        maxWidth: '300px',

        backgroundColor,
        borderRadius: '5px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        // textAlign: isMobile ? 'center' : 'left',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
    };

    const widgetBackdropStyle = {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 90,
    };

    const headerStyle = {
        backgroundColor: accentColor,
        borderRadius: '5px 5px 0 0',
        padding: "5px 10px",
        display: "flex",
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: "5px"
    }

    const contentStyle = {
        padding: "10px",
        display: 'flex',
        flexDirection: 'column',
        gap: "5px"
    }

    const buttonStyle = {
        ...position,
        backgroundColor: accentColor,
        padding: '10px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        cursor: 'pointer',
        gap: '5px'
    };

    const widget = (
        <>
            <div style={widgetBackdropStyle} onClick={() => setIsOpen(false)}></div>
            <div style={widgetStyle}>
                <div style={headerStyle}>
                    <div>{helperText}</div>
                    <FontAwesomeIcon icon={faWindowMaximize} rotation={180} onClick={() => setIsOpen(false)} style={{ cursor: "pointer" }} />
                </div>
                <div style={contentStyle}>
                    {content}
                </div>
            </div>
        </>
    );

    const button = (
        <div onClick={() => setIsOpen(true)} style={buttonStyle}>
            <span><FontAwesomeIcon icon={faCircleQuestion} /></span>
            {!isMobile && <span>{helperText}</span>}
        </div>
    )

    return isOpen ? widget : button
};
